import { render, staticRenderFns } from "./ScheduleEventBlock.vue?vue&type=template&id=63b011a8&"
import script from "./ScheduleEventBlock.vue?vue&type=script&lang=js&"
export * from "./ScheduleEventBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports